import { HOST } from "./../global";

export function buildParams(paramObj: any) {
  return Object.keys(paramObj)
    .map(k => {
      return `${k}=${paramObj[k]}`;
    })
    .join("&");
}

export function globalToLocalURL(url: string) {
  return url.replace(HOST, "");
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getDeviceSize(): string {
  let width = document.body.offsetWidth;
  if (width > 1024) {
    return "original";
  } else if (width > 425) {
    return "tab";
  } else {
    return "mobile";
  }
}

export function openInNewTab(url: string) {
  var win = window.open(url, "_blank");
  (win as Window).focus();
}
